const o = () => {
};
export {
  o as mapToVoid
};
//# sourceMappingURL=mapToVoid.js.map
